import { render, staticRenderFns } from "./MaterialPreview.vue?vue&type=template&id=b5cd5928&scoped=true"
import script from "./MaterialPreview.vue?vue&type=script&lang=js"
export * from "./MaterialPreview.vue?vue&type=script&lang=js"
import style0 from "./MaterialPreview.vue?vue&type=style&index=0&id=b5cd5928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cd5928",
  null
  
)

export default component.exports